import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { CheckCircle } from 'lucide-react';

const PackageCard = ({ pkg }) => {
  // Memoize the Link state object
  const linkState = useMemo(() => ({ selectedPackage: pkg.name }), [pkg.name]);

  return (
    <div
      className={`relative bg-white/5 backdrop-blur-sm border rounded-3xl p-8 transition-all duration-300 ${
        pkg.popular
          ? 'border-[#B8860B] shadow-2xl shadow-[#B8860B]/20 scale-105'
          : 'border-white/10 hover:border-[#B8860B]/30'
      }`}
    >
      {pkg.popular && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <Badge className="bg-gradient-to-r from-[#B8860B] to-[#C8960B] text-[#111216] font-bold px-4 py-1 text-sm">
            MOST POPULAR
          </Badge>
        </div>
      )}

      <div className="text-center mb-8">
        <h3 className="text-white font-bold text-2xl mb-2">{pkg.name}</h3>
        <div className="mb-2">
          <div className="text-[#B8860B] text-sm font-semibold mb-1">{pkg.priceRange}</div>
          <p className="text-gray-400 text-xs">Based on vehicle size</p>
        </div>
        <p className="text-gray-400 text-sm">{pkg.duration}</p>
      </div>

      <div className="space-y-4 mb-8">
        {pkg.features.map((feature) => (
          <div key={feature} className="flex items-start space-x-3">
            <CheckCircle className="w-5 h-5 text-[#B8860B] flex-shrink-0 mt-0.5" />
            <span className="text-gray-300 text-sm">{feature}</span>
          </div>
        ))}
      </div>

      <Link to="/booking" state={linkState}>
        <Button
          className={`w-full font-semibold ${
            pkg.popular
              ? 'bg-gradient-to-r from-[#B8860B] to-[#C8960B] hover:from-[#C8960B] hover:to-[#B8860B] text-[#111216]'
              : 'bg-white/10 hover:bg-white/20 text-white border border-white/20'
          }`}
        >
          Select Package
        </Button>
      </Link>
    </div>
  );
};

export default PackageCard;
